const keyPrefix = "regulator:shared-profile:";
const lastSavedKeyPrefix = "regulator:shared-profile-last-saved:";
const localRevisionKeyPrefix = "regulator:shared-profile-local-revision:";

export function sharedProfileToken(profileId, storage = localStorage) {
  return storage.getItem(`${keyPrefix}${profileId}`) || null;
}

export function rememberSharedProfile(profileId, token, storage = localStorage) {
  storage.setItem(`${keyPrefix}${profileId}`, token);
}

export function sharedProfileLastSavedAt(profileId, storage = localStorage) {
  return storage.getItem(`${lastSavedKeyPrefix}${profileId}`) || null;
}

export function rememberSharedProfileSavedAt(profileId, savedAt, storage = localStorage) {
  storage.setItem(`${lastSavedKeyPrefix}${profileId}`, savedAt);
}

export function sharedProfileLocalRevision(profileId, storage = localStorage) {
  return storage.getItem(`${localRevisionKeyPrefix}${profileId}`) || null;
}

export function rememberSharedProfileLocalRevision(profileId, updatedAt, storage = localStorage) {
  storage.setItem(`${localRevisionKeyPrefix}${profileId}`, updatedAt);
}

export function forgetSharedProfile(profileId, storage = localStorage) {
  storage.removeItem(`${keyPrefix}${profileId}`);
  storage.removeItem(`${lastSavedKeyPrefix}${profileId}`);
  storage.removeItem(`${localRevisionKeyPrefix}${profileId}`);
}
